/* 重构接口文件 */

import account from './modules/account';
import accountTs from './modules/account-ts';
import activity from './modules/activity';
import ambassadors from './modules/ambassadors';
import blackFriday from './modules/black-friday';
import blog from './modules/blog';
import cart from './modules/cart';
import cartTs from './modules/cart-ts';
import common from './modules/common';
import commonTs from './modules/common-ts';
import coupon from './modules/coupon';
import detail from './modules/detail';
import detailTs from './modules/detail-ts';
import index from './modules/index';
import indexTs from './modules/index-ts';
import list from './modules/list';
import listTs from './modules/list-ts';
import login from './modules/login';
import order from './modules/order';
import others from './modules/others';
import pay from './modules/pay';
import payTs from './modules/pay-ts';
import point from './modules/point';
import points from './modules/points';
import search from './modules/search';
import shopping from './modules/shopping';
import sitemap from './modules/sitemap';
import tryon from './modules/try-on';

export default {
  login,
  detail,
  detailTs,
  account,
  accountTs,
  cart,
  cartTs,
  common,
  commonTs,
  coupon,
  order,
  pay,
  payTs,
  list,
  listTs,
  index,
  indexTs,
  blog,
  activity,
  tryon,
  blackFriday,
  point,
  search,
  shopping,
  others,
  points,
  ambassadors,
  sitemap,
};
